import { Component, HostListener, OnInit } from '@angular/core';

import { AuthService } from '../../../../services/auth.service';
import { CompanyService } from '../../../../services/company.service';
import { CustomerTypeService } from '../../../../services/customer-type.service';
import { LocationService } from '../../../../services/location.service';
import { Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../../models/paging/page';
import { FillBatchReportService } from '../../../../services/fill-batch-report.service';
import { ModalService } from '../../../../services/modal.service';
import { Company } from '../../../../models/company';
import { Location } from '../../../../models/location';
import { SnotifyService } from 'ng-snotify';
import { UploadService } from '../../../../services/upload.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-upload-deliveries-collections',
  templateUrl: './upload-deliveries-collections.component.html',
  styleUrls: ['./upload-deliveries-collections.component.css']
})
export class UploadDeliveriesCollections implements OnInit {
  modalService: ModalService;
  companyService: CompanyService;
  locationService: LocationService;
  snotifyService: SnotifyService;
  uploadService: UploadService;

  companies: Company[];
  companyList: Company[];

  locations: Location[];
  locationList: Location[];

  filter: any = {
    date: moment().toDate(),
    upload_Type: 0,
    company_Id: 0,
    location_Id: 0
  };

  base64: string;
  dropFileText = "Drop your excel file here or click to browse.";
  showDownloadIcon = false;
  showUploadedFileIcon = false;
  downloadLink: string | null = null;
  showDownloadButton: boolean = false;
  fileResult: string | null = null;

  init: boolean;
  is_client = false;
  client;

  constructor(authService: AuthService, public fillBatchReportService: FillBatchReportService, public router: Router,
    modalService: ModalService, companyService: CompanyService, locationService: LocationService, snotifyService: SnotifyService, uploadService: UploadService) {
    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;
    this.modalService = modalService;
    this.companyService = companyService;
    this.locationService = locationService;
    this.snotifyService = snotifyService;
    this.uploadService = uploadService;

    companyService.getAll(0).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;

      locationService.getAll(this.filter.company_Id).then((data) => {
        this.locationList = data;
        this.locations = this.locationList;

      });
    });

  }

  ngOnInit() {
    this.init = true;
  }

  @HostListener('dragenter', ['$event']) onDragEnter(event: DragEvent) {
    this.preventAndStop(event);
    //console.log('Dragging entered the drop zone');
  }

  @HostListener('dragover', ['$event']) onDragOver(event: DragEvent) {
    this.preventAndStop(event);
    //console.log('Dragging over the drop zone');
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event: DragEvent) {
    this.preventAndStop(event);
    //console.log('Dragging left the drop zone');
  }


  @HostListener('drop', ['$event']) onDrop(event: DragEvent) {
    this.preventAndStop(event);

    const files = event.dataTransfer.files;
    if (files) {
      //console.log("Dropped Files: ", files)
      this.onFileDropped(event);
    }
  }

  private preventAndStop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const file = inputElement.files[0];

    inputElement.value = "";

    this.showDownloadButton = false;
    this.fileResult = null;

    if (file) {
      this.convertToBase64(file);
    }
  }

  onFileDropped(e: DragEvent) {
    let file = e.dataTransfer.files[0];
    if (file) {
      this.base64 = null;
      this.convertToBase64(file);
    }
  }

  convertToBase64(file: any): void {
    var rawBase64 = null;
    var base64 = null;

    // If a file was selected
    if (file) {

      if (!file.name.includes(".xlsx")) {
        this.snotifyService.error("Invalid format, please select an Excel file (.xlsx).", { timeout: 5000 });
        console.log("Invalid Format");
        this.showDownloadIcon = false;
        return;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file);

      // Split the initial data type string from the base64 data
      reader.onload = (e) => {
        rawBase64 = reader.result;
        base64 = rawBase64.split(",", 2);
        this.base64 = base64[1];
      };

      reader.onerror = function (error) {
        console.log('Error: ', error);
      };

      this.dropFileText = file.name;
      this.showUploadedFileIcon = true;
      this.showDownloadIcon = false;
    }
  }

  upload(): void {

    if (this.filter.upload_Type == 0) {
      this.snotifyService.error("Please select collection or delivery.", { timeout: 5000 });
      return;
    }

    if (this.filter.customer_Id == 0) {
      this.snotifyService.error("Please select a customer.", { timeout: 5000 });
      return;
    }

    if (this.filter.location_Id == 0) {
      this.snotifyService.error("Please select a location.", { timeout: 5000 });
      return;
    }
    console.log(this.filter);
    console.log(this.base64);
    if (this.base64 != null) {
      this.uploadService.uploadDeliveriesCollections(this.base64, this.client.userId, this.filter.upload_Type,
        this.filter.company_Id, this.filter.location_Id, moment(this.filter.date).format('YYYY-MM-DD')).then((data) => {

          this.removeUpload();
          console.log("data back from uplaod", data);

          if (data.success == true && data.fileResult) {
            this.snotifyService.success(data.message, { timeout: 3000 });
            this.fileResult = data.fileResult;
            this.showDownloadButton = true;

          } else if (!data.fileResult) {
            this.snotifyService.error("The uploaded file contains no data", {
              timeout: 5000,
            });
            this.showDownloadButton = false;
          }
          else {
            this.fileResult = data.fileResult;
            this.showDownloadButton = true;
            this.snotifyService.error("Error uploading cylinders: " + data.message, { timeout: 5000 });
          }

        }).catch((err) => {
          this.removeUpload();
          this.snotifyService.error("Error, unable to upload cylinders.", { timeout: 3000 });
        });
    }
    else {
      this.snotifyService.error("Please upload an excel file.", { timeout: 5000 });
    }
  }

  createDownloadLink(base64: string, fileName: string) {
    if (!base64) {
      this.snotifyService.error("No file available for download.", {
        timeout: 5000,
      });
      return;
    }
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    FileSaver.saveAs(blob, fileName);
  }

  removeUpload() {
    this.dropFileText = 'Drop your excel file here or click to browse.';
    this.showUploadedFileIcon = false;
    this.base64 = null;
    this.showDownloadButton = false;
    this.fileResult = null;
  }

  onUploadDragOver() {
    this.showDownloadIcon = true;
  }

  onUploadDragLeave() {
    this.showDownloadIcon = false;
  }

  onCompanyChange(value) {
    this.filter.location_Id = 0;

    if (value == 0) { value = null; }

    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }

  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
}

